import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Icon from "@shared/components/Icon";
import Link from "@shared/components/contents/link/Link";
import React from "react";
const Social = (props) => {
    const { socialNetworks } = props;
    return socialNetworks.map((social) => {
        const { id, icon, ...others } = social.icon;
        const { id: idSocial, url, title } = social;
        if (url && icon) {
            return (_jsx(Link, { url: url, external: true, title: title, children: _jsx(Icon, { icon: icon, ...others, style: { fontSize: "24px" } }) }, idSocial));
        }
        if (url) {
            return (_jsx(Link, { url: url, external: true, title: title, children: title }, idSocial));
        }
        return _jsx(_Fragment, {});
    });
};
export default Social;
